export default function getValidbenefits(flat) {
  const res = flat?.benefits?.mortgage
    ?.filter(el => {
      const isValidMortgage =
        el?.mortgage?.maxPeriod &&
        el?.mortgage?.firstPayment &&
        el?.mortgage?.maxPrice &&
        el?.mortgage?.minPrice &&
        el?.mortgage?.minPeriod &&
        el?.mortgage?.minMonthFee;
      if (isValidMortgage) return el;
      return null;
    })
    ?.sort((a, b) => a?.mortgage?.minMonthFee - b?.mortgage?.minMonthFee);
  return res;
}
